import React, { forwardRef } from 'react'
import { Tooltip } from '@chakra-ui/react'
import { IconButton } from '@chakra-ui/react'
import type { TooltipProps } from '@chakra-ui/react'
import type { IconButtonProps } from '@chakra-ui/react'

export interface IconButtonWithTooltipProps
    extends Omit<IconButtonProps, 'aria-label'> {
    label: string
    tooltipOverrides?: Omit<TooltipProps, 'label' | 'children'>
}

const IconButtonWithTooltip: React.ForwardRefRenderFunction<
    HTMLButtonElement,
    IconButtonWithTooltipProps
> = ({ label, tooltipOverrides, ...props }, ref) => {
    return (
        <Tooltip label={label} hasArrow {...tooltipOverrides}>
            <IconButton {...props} ref={ref} aria-label={label} />
        </Tooltip>
    )
}

export default forwardRef<HTMLButtonElement, IconButtonWithTooltipProps>(
    IconButtonWithTooltip,
)
